import React from 'react';
import CascadingApprovalSummaryTable from "../../CascadingApprovalSummary/components/CascadingApprovalSummaryTable";

const AprovalHistoryTable = (props) => (
  <CascadingApprovalSummaryTable {...props} reportPath="award-approvals-history" />
);

export default AprovalHistoryTable;
